import { Component, OnInit, Inject } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { BranchService } from '../../services/branch.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { BranchDetailsFormControls, OrdersMessages, productMessage } from 'app/pages/constants';
import { BundleTimeSlot } from '../bundle-time-slot';

@Component({
  selector: 'app-delivery-type-dialog',
  templateUrl: './delivery-type-dialog.component.html',
  styleUrls: ['./delivery-type-dialog.component.scss'],
})
export class DeliveryTypeDialogComponent implements OnInit {
  private onValidatorChange = () => { };

  bundledForm: FormGroup;
  onDemandForm: FormGroup;
  id: number;
  selectedTabindex: number;
  weekdays: boolean;
  deliveryType: string;
  formType: string;
  public formControl = BranchDetailsFormControls;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DeliveryTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private branchService: BranchService,
    private notifyService: NotificationService,
    private translate: TranslateService
  ) {
    this.id = this.data.deliverytypeid;
    if (this.id) {
      this.getDeliveryType(this.id);
    }

    this.deliveryType = 'both';
  }

  condition(field1: any = null, field2: any = null, field3: any = null) {
    // check if one field is required secound should be required
    if (
      !this.bundledForm.value[field1] &&
      !this.bundledForm.value[field2] &&
      !this.bundledForm.value[field3]
    ) {
      // if both null true
      this.bundledForm.get([field1]).setErrors(null);
      this.bundledForm.get([field2]).setErrors(null);
      this.bundledForm.get([field3]).setErrors(null);
      this.weekdays = false;
    } else if (
      this.bundledForm.value[field1] &&
      this.bundledForm.value[field2] &&
      this.bundledForm.value[field3]
    ) {
      // if both not null true
      this.bundledForm.get([field1]).setErrors(null);
      this.bundledForm.get([field2]).setErrors(null);
      this.bundledForm.get([field3]).setErrors(null);
      this.weekdays = false;
    } else if (
      this.bundledForm.value[field1] &&
      !this.bundledForm.value[field2] &&
      !this.bundledForm.value[field3]
    ) {
      // if first
      this.bundledForm.get([field3]).setValidators([Validators.required]);
      this.bundledForm.get([field3]).updateValueAndValidity();

      this.bundledForm.get([field2]).setValidators([Validators.required]);
      this.bundledForm.get([field2]).updateValueAndValidity();

      this.weekdays = true;
    } else if (
      !this.bundledForm.value[field1] &&
      !this.bundledForm.value[field2] &&
      this.bundledForm.value[field3]
    ) {
      // if third
      this.bundledForm.get([field2]).setValidators([Validators.required]);
      this.bundledForm.get([field2]).updateValueAndValidity();

      this.bundledForm.get([field1]).setValidators([Validators.required]);
      this.bundledForm.get([field1]).updateValueAndValidity();
      this.weekdays = true;
    } else if (
      !this.bundledForm.value[field1] &&
      this.bundledForm.value[field2] &&
      !this.bundledForm.value[field3]
    ) {
      // if secound
      this.bundledForm.get([field3]).setValidators([Validators.required]);
      this.bundledForm.get([field3]).updateValueAndValidity();

      this.bundledForm.get([field1]).setValidators([Validators.required]);
      this.bundledForm.get([field1]).updateValueAndValidity();
      this.weekdays = true;
    } else if (
      this.bundledForm.value[field1] &&
      !this.bundledForm.value[field2] &&
      this.bundledForm.value[field3]
    ) {
      this.bundledForm.get([field2]).setValidators([Validators.required]);
      this.bundledForm.get([field2]).updateValueAndValidity();
      this.weekdays = true;
    } else if (
      this.bundledForm.value[field1] &&
      this.bundledForm.value[field2] &&
      !this.bundledForm.value[field3]
    ) {
      this.bundledForm.get([field3]).setValidators([Validators.required]);
      this.bundledForm.get([field3]).updateValueAndValidity();
      this.weekdays = true;
    } else if (
      !this.bundledForm.value[field1] &&
      this.bundledForm.value[field2] &&
      this.bundledForm.value[field3]
    ) {
      this.bundledForm.get([field1]).setValidators([Validators.required]);
      this.bundledForm.get([field1]).updateValueAndValidity();
      this.weekdays = true;
    } else {
      //both validate true
      this.bundledForm.get([field1]).setErrors(null);
      this.bundledForm.get([field2]).setErrors(null);
      this.bundledForm.get([field3]).setErrors(null);
      this.weekdays = true;
    }
    //***** weekdays days true ? disable else enable mat-tab */
  }

  // ------------------------------------------------------------------------------------------------
  // @ Set form group key and if edit category - get detail by id
  // ------------------------------------------------------------------------------------------------
  ngOnInit() {
    this.bundledForm = this.fb.group({
      uid: [''],
      monday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      tuesday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      wednesday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      thursday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      friday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      saturday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
      sunday: [{
        time: '',
        cutOff: '',
        maxOrders: ''
      }],
    });

    this.onDemandForm = this.fb.group({
      uid: [''],
      slotinterval: [''],
      ondemandcutoff: [''],
      maximumorders: [''],
    });
  }

  private validateAndGetOnDemandFormData() {
    if (this.onDemandForm.invalid) {
      this.onDemandForm.markAllAsTouched();
      return null;
    }
    const value = this.createFormattedArray();
    if (this.bundledForm.valid && value !== '' && !confirm(this.translate.instant("pages.branches.deliveryTypeDialog.confirmOnDemand"))) {
      return null;
    }
    return {
      uid: this.onDemandForm.value.uid,
      slotinterval: this.onDemandForm.value.slotinterval,
      ondemandcutoff: this.onDemandForm.value.ondemandcutoff,
      maximumorders: this.onDemandForm.value.maximumorders,
      mondayby: '',
      mondaycutoff: '',
      mondaymaximumorders: '',
      tuesdayby: '',
      tuesdaycutoff: '',
      tuesdaymaximumorders: '',
      wednesdayby: '',
      wednesdaycutoff: '',
      wednesdaymaximumorders: '',
      thursdayby: '',
      thursdaycutoff: '',
      thursdaymaximumorders: '',
      fridayby: '',
      fridaycutoff: '',
      fridaymaximumorders: '',
      saturdayby: '',
      saturdaycutoff: '',
      saturdaymaximumorders: '',
      sundayby: '',
      sundaycutoff: '',
      sundaymaximumorders: '',
      value: '',
    };
  }

  private validateAndGetBundledFormData() {
    if (this.bundledForm.invalid) {
      this.bundledForm.markAllAsTouched();
      return null;
    }
    const value = this.createFormattedArray();
    if (value === '') {
      this.notifyService.showError(
        this.translate.instant(OrdersMessages.invalidForm),
        this.translate.instant(OrdersMessages.error)
      );
      return null;
    } else if (this.onDemandForm.valid && this.onDemandForm.value.slotinterval && !confirm(this.translate.instant("pages.branches.deliveryTypeDialog.confirmBundle"))) {
      return null;
    }
    return {
      uid: this.bundledForm.value.uid,
      slotinterval: '',
      ondemandcutoff: '',
      maximumorders: '',
      mondayby: this.bundledForm.value.monday.time,
      mondaycutoff: this.bundledForm.value.monday.cutOff,
      mondaymaximumorders: this.bundledForm.value.monday.maxOrders,
      tuesdayby: this.bundledForm.value.tuesday.time,
      tuesdaycutoff: this.bundledForm.value.tuesday.cutOff,
      tuesdaymaximumorders: this.bundledForm.value.tuesday.maxOrders,
      wednesdayby: this.bundledForm.value.wednesday.time,
      wednesdaycutoff: this.bundledForm.value.wednesday.cutOff,
      wednesdaymaximumorders: this.bundledForm.value.wednesday.maxOrders,
      thursdayby: this.bundledForm.value.thursday.time,
      thursdaycutoff: this.bundledForm.value.thursday.cutOff,
      thursdaymaximumorders: this.bundledForm.value.thursday.maxOrders,
      fridayby: this.bundledForm.value.friday.time,
      fridaycutoff: this.bundledForm.value.friday.cutOff,
      fridaymaximumorders: this.bundledForm.value.friday.maxOrders,
      saturdayby: this.bundledForm.value.saturday.time,
      saturdaycutoff: this.bundledForm.value.saturday.cutOff,
      saturdaymaximumorders: this.bundledForm.value.saturday.maxOrders,
      sundayby: this.bundledForm.value.sunday.time,
      sundaycutoff: this.bundledForm.value.sunday.cutOff,
      sundaymaximumorders: this.bundledForm.value.sunday.maxOrders,
      value: value,
    };
  }

  submitForm(type = '') {
    let formData;
    if (type == "onDemandForm") {
      formData = this.validateAndGetOnDemandFormData();
    } else {
      formData = this.validateAndGetBundledFormData();
    }

    if (!formData) {
      return;
    }


    if (this.id) {
      this.updateDeliveryType(formData);
    } else {
      this.addDeliveryType(formData);
    }
  }

  onNoClick(res_id = null): void {
    this.dialogRef.close({ uid: res_id });
  }
  tabChanged = ($event): void => {
    console.log('tabChangeEvent => ', $event);
    this.selectedTabindex = $event.index;
  }
  // ------------------------------------------------------------------------------------------------
  // @ If this is update form, get user details and update form group
  // ------------------------------------------------------------------------------------------------
  getDeliveryType(index: number) {
    this.branchService.getDeliveryType(index).subscribe(
      (response: any) => {
        this.deliveryType = response.type;
        this.onDemandForm.patchValue(response);
        // this.bundledForm.patchValue(response);
        this.bundledForm.patchValue({
          uid: response.uid,
          monday: {
            time: response.mondayby,
            cutOff: response.mondaycutoff,
            maxOrders: response.mondaymaximumorders,
          },
          tuesday: {
            time: response.tuesdayby,
            cutOff: response.tuesdaycutoff,
            maxOrders: response.tuesdaymaximumorders,
          },
          wednesday: {
            time: response.wednesdayby,
            cutOff: response.wednesdaycutoff,
            maxOrders: response.wednesdaymaximumorders,
          },
          thursday: {
            time: response.thursdayby,
            cutOff: response.thursdaycutoff,
            maxOrders: response.thursdaymaximumorders,
          },
          friday: {
            time: response.fridayby,
            cutOff: response.fridaycutoff,
            maxOrders: response.fridaymaximumorders,
          },
          saturday: {
            time: response.saturdayby,
            cutOff: response.saturdaycutoff,
            maxOrders: response.saturdaymaximumorders,
          },
          sunday: {
            time: response.sundayby,
            cutOff: response.sundaycutoff,
            maxOrders: response.sundaymaximumorders,
          },
        });
      },
      (err) => {
        console.log(err);
        // this.errors = err;
      }
    );
  }

  // ------------------------------------------------------------------------------------------------
  // @ Add
  // ------------------------------------------------------------------------------------------------
  addDeliveryType(data) {
    data.uid = data.uid || 0;
    this.branchService.addDeliveryType(data).subscribe(
      (response: any) => {
        if (response.success == true) {
          this.onNoClick(response.data.uid); // store result id
          this.notifyService.showSuccess(
            this.translate.instant(productMessage.add),
            this.translate.instant(OrdersMessages.success)
          );
        } else {
          this.notifyService.showError(
            response.message,
            this.translate.instant(OrdersMessages.error)
          );
        }
      },
      (err) => {
        //	this.errors = err;
      }
    );
  }

  // ------------------------------------------------------------------------------------------------
  // @ Update
  // ------------------------------------------------------------------------------------------------
  updateDeliveryType(data) {
    this.branchService.updateDeliveryType(data).subscribe(
      (response: any) => {
        if (response.success == true) {
          // updated
          this.onNoClick(response.data.uid); // store result id
          this.notifyService.showSuccess(
            this.translate.instant(OrdersMessages.update),
            this.translate.instant(OrdersMessages.success)
          );
        } else {
          this.notifyService.showError(
            response.message,
            this.translate.instant(OrdersMessages.error)
          );
        }
      },
      (err) => {
        //  this.errors = err;
      }
    );
  }

  // ------------------------------------------------------------------------------------------------
  // @ Delete
  // ------------------------------------------------------------------------------------------------
  deleteDeliveryType(slotId: number) {
    if (confirm(this.translate.instant(OrdersMessages.confirmDelete))) {
      this.branchService.deleteDeliveryType(slotId).subscribe(
        (response: any) => {
          if (response.success == true) {
            // delete
            this.notifyService.showSuccess(
              this.translate.instant(OrdersMessages.delete),
              this.translate.instant(OrdersMessages.success)
            );
            this.onNoClick(null);
          } else if (
            response.success == false &&
            response.code == 'timeslot_Associated'
          ) {
            // Associate
            this.notifyService.showError(
              this.translate.instant(OrdersMessages.timeslotAssociated),
              this.translate.instant(OrdersMessages.error)
            );
          }
        },
        (err) => {
          // this.errors = err;
        }
      );
    } else {
      // Do nothing!
      console.log('Thing was not saved to the database.');
    }
  }

  // ------------------------------------------------------------------------------------------------
  // @ Create formatted array for timeslot calender on mobile app site
  // ------------------------------------------------------------------------------------------------
  mapDay(day: BundleTimeSlot) {
    const isValid = !!day?.time;
    console.dir(day);
    return {
      from: day.time,
      to: '',
      cut_off: (isValid) ? day.cutOff : null,
      maximumorders: (isValid) ? day.maxOrders : null,
      closed: !isValid,
    };
  }
  createFormattedArray() {
    console.log("this.bundledForm.value", this.bundledForm.value);
    var weekDataArr = [
      {
        weekday: 1,
        weekday_formatted: 'monday',
        ...this.mapDay(this.bundledForm.value.monday),
      },
      {
        weekday: 2,
        weekday_formatted: 'tuesday',
        ...this.mapDay(this.bundledForm.value.tuesday),
      },
      {
        weekday: 3,
        weekday_formatted: 'wednesday',
        ...this.mapDay(this.bundledForm.value.wednesday),
      },
      {
        weekday: 4,
        weekday_formatted: 'thursday',
        ...this.mapDay(this.bundledForm.value.thursday),
      },
      {
        weekday: 5,
        weekday_formatted: 'friday',
        ...this.mapDay(this.bundledForm.value.friday),
      },
      {
        weekday: 6,
        weekday_formatted: 'saturday',
        ...this.mapDay(this.bundledForm.value.saturday),
      },
      {
        weekday: 7,
        weekday_formatted: 'sunday',
        ...this.mapDay(this.bundledForm.value.sunday),
      },
    ];
    if (weekDataArr.every(day => day.closed)) {
      return '';
    }

    return JSON.stringify(weekDataArr);
  }

  onValueChange(): void {
    // Trigger validation update for parent form when any value changes
    this.onValidatorChange();
  }
}
